<template>
  <div class="content-wrapper">
    <div class="mt-5 mb-4"></div>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4">
            <img
              src="../../public/img/construccion.jpg"
              class="product-image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
};
</script>